import { AcaoNotaFiscalEntradaEnum } from '../../../enums/suprimentos/acao-nota-fiscal-entrada.enum';

/** Item do menu de contexto da nota fiscal de entrada, já resolvido para a linha; a primeira ação é a principal. */
export class AcaoNotaFiscalEntradaStruct {
  public acao: AcaoNotaFiscalEntradaEnum;
  public rotulo: string;
  public icone: string;
  public isDisponivel: boolean;
  /** Motivo exibido em tooltip quando a ação está indisponível. */
  public motivoIndisponivel: string;
}
